import { render, staticRenderFns } from "./CustomizationBottomOperateQrNfc.vue?vue&type=template&id=85df4b9a&scoped=true&"
import script from "./CustomizationBottomOperateQrNfc.vue?vue&type=script&lang=js&"
export * from "./CustomizationBottomOperateQrNfc.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationBottomOperateQrNfc.vue?vue&type=style&index=0&id=85df4b9a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85df4b9a",
  null
  
)

export default component.exports